import React, { useRef } from 'react';
import { Col } from 'antd';
import { StepFlexRow } from "../../../../../../CommonComponents/commonStyles";
import { FlowSteps as Steps } from './styles';

const Stepper = (props) => {
    return (
        <StepFlexRow>
            <Col lg={{ span: 4 }}>
                <Steps current={props.current} >
                    {props.steps && props.steps({current : props.current}).map((Item) => Item)}
                </Steps>
            </Col>
            <Col lg={{ span: 20 }}>
                {props.children}
            </Col>
        </StepFlexRow>
    );
};

export default Stepper;